var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0005 8.50024L2.00048 8.50024M21.0005 8.50024L21.0005 11.0002L24.0005 8.50024L21.0005 6.50024V8.50024ZM18.5005 2.00024L2.00048 2.00024M18.5005 15.0002L2.00048 15.0002",
    stroke: "#2B6B9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarIconRight);
export default __webpack_public_path__ + "static/media/bar-icon-right.c25cbe3efb14ae276079db51e4a778e8.svg";
export { ForwardRef as ReactComponent };